import { Injectable, EventEmitter } from '@angular/core';
import * as siganalR from "@microsoft/signalr";
import { environment } from '../../../environments/environment';
import { API } from '../config/api';
import { Subject} from 'rxjs';
import { Users } from '../../models';
import { UserInfoModel } from '../login';

@Injectable({
  providedIn: 'root'
})
export class SignalRService {
  public baseUrl = environment.baseUrl;
  private hubConnection: siganalR.HubConnection;
  signalHXQuoteRecived = new EventEmitter<any>();
  public QuotesBooked = new Subject<any>();
  public HxNotifications = new Subject<any>();
  //public bristolQuotesBooked = new Observable<any>();
  public UserIsBranch1: boolean = true;
  public myUser: UserInfoModel;
  

  constructor() {
    this.buildConnection();
    this.startConnection();
  };

  private startConnection = () => {
    var that = this;
    this.hubConnection
      .start()
      .then(() => {
        console.log("SignalR Starting ....");
        this.registerSignalEvent();
      })
      .catch(err => {
        console.log("SignalR err: " + err);
        setTimeout(function () {
          that.startConnection();
        }, 3000);
      });
  };

  //public setQuoteBranch(isBranch1 :boolean) {
  //  let b1qs = API.SIGNALR.BIRMINGHAM_QUOTE_BOOKED;
  //  let b2qs = API.SIGNALR.BRISTOL_QUOTE_BOOKED;
  //  this.UserIsBranch1 = isBranch1;
  //  if (isBranch1) {
  //    this.hubConnection.on(b1qs, (data) => {

  //      //console.log(data);
  //      this.QuotesBooked.next(true);
  //    });
  //  } else {
  //    this.hubConnection.on(b2qs, (data) => {

  //      this.QuotesBooked.next(true);
  //    });
  //  }

  //}

  public setQuoteBranch(branchFlag: string) {
    let b1qs = API.SIGNALR.BIRMINGHAM_QUOTE_BOOKED;
    let b2qs = API.SIGNALR.BRISTOL_QUOTE_BOOKED;
    let b3qs = API.SIGNALR.GLOBAL_QUOTE_BOOKED;
    if (branchFlag === "BM") {
      this.hubConnection.on(b1qs, (data) => {

        //console.log(data);
        this.QuotesBooked.next(true);
      });
    }
    else if (branchFlag === "BL")
    {
      this.hubConnection.on(b2qs, (data) => {

        this.QuotesBooked.next(true);
      });
    }
    else if (branchFlag === "GL") {
      this.hubConnection.on(b3qs, (data) => {

        this.QuotesBooked.next(true);
      });
    }
  }


  //public startConnection = () => {
  //  this.hubConnection
  //    .start()
  //    .then(() => {
  //      console.log("SignalR Starting ...."); this.registerSignalEvent()
  //    })

  //    .catch(err => { console.log("SignalR err: " + err); setTimeout(function () { this.startConnection(); }, 3000); });

  //}

  private buildConnection() {
    let s = this.baseUrl + `${API.SIGNALR.SIGNALHUB}`;

    this.hubConnection = new siganalR.HubConnectionBuilder()
      .withUrl(s)
      .withAutomaticReconnect()
      .configureLogging(siganalR.LogLevel.Information)
      .build();
  };

  private registerSignalEvent() {
    let s1 = API.SIGNALR.HX_QUOTE_RECIEVED;
    //let s2 = API.SIGNALR.GENERAL_ALERT;
    let s2 = API.SIGNALR.HX_QUOTE_CANCELLED;
    let s3 = API.SIGNALR.HX_NOTIFICATION_ACK;
    let s4 = API.SIGNALR.HX_NO_QUOTES;
    let s5 = API.SIGNALR.HX_STATUS_UPDATE;
    let s6 = API.SIGNALR.HX_NO_STATUS;

    this.hubConnection.on(s1, (data: any) => {
      //console.log("SignalR HX Quote Received")
      //this.signalHXQuoteRecived.emit(data);
      this.HxNotifications.next(true);
    });

    this.hubConnection.on(s2, (data: any) => {
      //console.log("SignalR HX Quote Cancelled")
      this.HxNotifications.next(true);
    });
    
    this.hubConnection.on(s3, (data) => {     
      //console.log("SignalR HX Notification Acknowledged")
      this.HxNotifications.next(true);
    });

    this.hubConnection.on(s4, (data) => {     
      //console.log("SignalR HX No Quotes")
      this.HxNotifications.next(true);
    });

    this.hubConnection.on(s5, (data) => {     
      //console.log("SignalR HX Status Update")
      this.HxNotifications.next(true);
    });

    this.hubConnection.on(s6, (data) => {
      //console.log("SignalR HX No Status")
      this.HxNotifications.next(true);
    });

  }
}
